import splitDeepLink from "~/helpers/aiChat/deepLinkParts";

export const REPORTS_PATH = "/reports";

export type ReportDeepLinkTarget = { kind: "report"; reportName: string } | { kind: "other" };

const parseReportDeepLink = (deepLink: string): ReportDeepLinkTarget => {
	const { pathname, search } = splitDeepLink(deepLink);
	if (pathname !== REPORTS_PATH) return { kind: "other" };
	const reportName = search.get("report")?.trim();
	return reportName ? { kind: "report", reportName } : { kind: "other" };
};

export default parseReportDeepLink;
